<template>
<svg version="1.1" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="63.251px" height="78.67px" viewBox="0 0 63.251 78.67">
	<title>Погружной насос</title>
	<defs>
		<linearGradient id="SP_SVGID_1_" gradientUnits="userSpaceOnUse" x1="23.251" y1="11.6665" x2="56.251" y2="11.6665">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_3_" gradientUnits="userSpaceOnUse" x1="2.251" y1="73" x2="63.251" y2="73">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_6_" gradientUnits="userSpaceOnUse" x1="22.417" y1="35.708" x2="57.668" y2="35.708">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_7_" gradientUnits="userSpaceOnUse" x1="10.8086" y1="-0.4702" x2="42.8086" y2="17.1968">
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#919191" />
		</linearGradient>
		<linearGradient id="SP_SVGID_8_" gradientUnits="userSpaceOnUse" x1="34.667" y1="3.833" x2="44.918" y2="3.833">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_9_" gradientUnits="userSpaceOnUse" x1="36.084" y1="0.833" x2="44.167" y2="0.833">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_12_" gradientUnits="userSpaceOnUse" x1="19.833" y1="59.3745" x2="58.375" y2="59.3745">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_13_" gradientUnits="userSpaceOnUse" x1="19.4375" y1="52.5615" x2="21.5625" y2="52.5615">
			<stop offset="0" style="stop-color:#919191" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D6D6D6" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#919191" />
		</linearGradient>
		<linearGradient id="SP_SVGID_14_" gradientUnits="userSpaceOnUse" x1="56.9375" y1="52.5615" x2="59.0625" y2="52.5615">
			<stop offset="0" style="stop-color:#919191" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D6D6D6" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#919191" />
		</linearGradient>
		<linearGradient id="SP_SVGID_15_" gradientUnits="userSpaceOnUse" x1="37.5" y1="52.5615" x2="39.625" y2="52.5615">
			<stop offset="0" style="stop-color:#919191" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D6D6D6" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#919191" />
		</linearGradient>
		<linearGradient id="SP_SVGID_16_" gradientUnits="userSpaceOnUse" x1="21.2959" y1="40.1973" x2="24.5879" y2="40.1973">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_17_" gradientUnits="userSpaceOnUse" x1="55.3799" y1="35.3223" x2="58.6719" y2="35.3223">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_18_" gradientUnits="userSpaceOnUse" x1="27.9277" y1="40.1973" x2="30.6707" y2="40.1973">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_19_" gradientUnits="userSpaceOnUse" x1="41.5947" y1="40.1973" x2="44.3377" y2="40.1973">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_20_" gradientUnits="userSpaceOnUse" x1="49.3447" y1="40.1973" x2="52.0877" y2="40.1973">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>
		<linearGradient id="SP_SVGID_21_" gradientUnits="userSpaceOnUse" x1="34.4277" y1="35.3223" x2="37.1707" y2="35.3223">
			<stop offset="0" style="stop-color:#606060" />
			<stop offset="0.1011" style="stop-color:#646464" />
			<stop offset="0.2113" style="stop-color:#707070" />
			<stop offset="0.25" style="stop-color:#767676" />
			<stop offset="0.5" style="stop-color:#BABABA" />
			<stop offset="0.75" style="stop-color:#767676" />
			<stop offset="0.7981" style="stop-color:#6E6E6E" />
			<stop offset="0.8972" style="stop-color:#646464" />
			<stop offset="1" style="stop-color:#606060" />
		</linearGradient>

		<linearGradient id="green_1_" gradientUnits="userSpaceOnUse" x1="23.251" y1="11.6665" x2="56.251" y2="11.6665">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_3_" gradientUnits="userSpaceOnUse" x1="2.251" y1="73" x2="63.251" y2="73">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_6_" gradientUnits="userSpaceOnUse" x1="22.417" y1="35.708" x2="57.668" y2="35.708">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_7_" gradientUnits="userSpaceOnUse" x1="10.8086" y1="-0.4702" x2="42.8086" y2="17.1968">
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#929192" />
		</linearGradient>
		<linearGradient id="green_8_" gradientUnits="userSpaceOnUse" x1="34.667" y1="3.833" x2="44.918" y2="3.833">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_9_" gradientUnits="userSpaceOnUse" x1="36.084" y1="0.833" x2="44.167" y2="0.833">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_12_" gradientUnits="userSpaceOnUse" x1="19.833" y1="59.3745" x2="58.375" y2="59.3745">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_13_" gradientUnits="userSpaceOnUse" x1="19.4375" y1="52.5615" x2="21.5625" y2="52.5615">
			<stop offset="0" style="stop-color:#929192" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D7D6D7" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#929192" />
		</linearGradient>
		<linearGradient id="green_14_" gradientUnits="userSpaceOnUse" x1="56.9375" y1="52.5615" x2="59.0625" y2="52.5615">
			<stop offset="0" style="stop-color:#929192" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D7D6D7" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#929192" />
		</linearGradient>
		<linearGradient id="green_15_" gradientUnits="userSpaceOnUse" x1="37.5" y1="52.5615" x2="39.625" y2="52.5615">
			<stop offset="0" style="stop-color:#929192" />
			<stop offset="0.0824" style="stop-color:#A7A7A7" />
			<stop offset="0.2824" style="stop-color:#D7D6D7" />
			<stop offset="0.4356" style="stop-color:#F4F4F4" />
			<stop offset="0.5225" style="stop-color:#FFFFFF" />
			<stop offset="0.599" style="stop-color:#F5F5F5" />
			<stop offset="0.7277" style="stop-color:#DBDBDB" />
			<stop offset="0.892" style="stop-color:#B1B1B1" />
			<stop offset="1" style="stop-color:#929192" />
		</linearGradient>
		<linearGradient id="green_16_" gradientUnits="userSpaceOnUse" x1="21.2959" y1="40.1973" x2="24.5879" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_17_" gradientUnits="userSpaceOnUse" x1="55.3799" y1="35.3223" x2="58.6719" y2="35.3223">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_18_" gradientUnits="userSpaceOnUse" x1="27.9277" y1="40.1973" x2="30.6707" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_19_" gradientUnits="userSpaceOnUse" x1="41.5947" y1="40.1973" x2="44.3377" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_20_" gradientUnits="userSpaceOnUse" x1="49.3447" y1="40.1973" x2="52.0877" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>
		<linearGradient id="green_21_" gradientUnits="userSpaceOnUse" x1="34.4277" y1="35.3223" x2="37.1707" y2="35.3223">
			<stop offset="0" style="stop-color:#2E6060" />
			<stop offset="0.1011" style="stop-color:#326464" />
			<stop offset="0.2113" style="stop-color:#407071" />
			<stop offset="0.25" style="stop-color:#467677" />
			<stop offset="0.5" style="stop-color:#8DBAB9" />
			<stop offset="0.75" style="stop-color:#467677" />
			<stop offset="0.7981" style="stop-color:#3D6E6F" />
			<stop offset="0.8972" style="stop-color:#326464" />
			<stop offset="1" style="stop-color:#2E6060" />
		</linearGradient>


		<linearGradient id="red_1_" gradientUnits="userSpaceOnUse" x1="23.251" y1="11.6665" x2="56.251" y2="11.6665">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_3_" gradientUnits="userSpaceOnUse" x1="2.251" y1="73" x2="63.251" y2="73">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_6_" gradientUnits="userSpaceOnUse" x1="22.417" y1="35.708" x2="57.668" y2="35.708">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_7_" gradientUnits="userSpaceOnUse" x1="10.8086" y1="-0.4702" x2="42.8086" y2="17.1968">
			<stop offset="0.5225" style="stop-color:#FF0000" />
			<stop offset="0.599" style="stop-color:#F50000" />
			<stop offset="0.7277" style="stop-color:#DB0000" />
			<stop offset="0.892" style="stop-color:#B10000" />
			<stop offset="1" style="stop-color:#920000" />
		</linearGradient>
		<linearGradient id="red_8_" gradientUnits="userSpaceOnUse" x1="34.667" y1="3.833" x2="44.918" y2="3.833">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_9_" gradientUnits="userSpaceOnUse" x1="36.084" y1="0.833" x2="44.167" y2="0.833">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_12_" gradientUnits="userSpaceOnUse" x1="19.833" y1="59.3745" x2="58.375" y2="59.3745">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_13_" gradientUnits="userSpaceOnUse" x1="19.4375" y1="52.5615" x2="21.5625" y2="52.5615">
			<stop offset="0" style="stop-color:#920000" />
			<stop offset="0.0824" style="stop-color:#A70000" />
			<stop offset="0.2824" style="stop-color:#D70000" />
			<stop offset="0.4356" style="stop-color:#F40000" />
			<stop offset="0.5225" style="stop-color:#FF0000" />
			<stop offset="0.599" style="stop-color:#F50000" />
			<stop offset="0.7277" style="stop-color:#DB0000" />
			<stop offset="0.892" style="stop-color:#B10000" />
			<stop offset="1" style="stop-color:#920000" />
		</linearGradient>
		<linearGradient id="red_14_" gradientUnits="userSpaceOnUse" x1="56.9375" y1="52.5615" x2="59.0625" y2="52.5615">
			<stop offset="0" style="stop-color:#920000" />
			<stop offset="0.0824" style="stop-color:#A70000" />
			<stop offset="0.2824" style="stop-color:#D70000" />
			<stop offset="0.4356" style="stop-color:#F40000" />
			<stop offset="0.5225" style="stop-color:#FF0000" />
			<stop offset="0.599" style="stop-color:#F50000" />
			<stop offset="0.7277" style="stop-color:#DB0000" />
			<stop offset="0.892" style="stop-color:#B10000" />
			<stop offset="1" style="stop-color:#920000" />
		</linearGradient>
		<linearGradient id="red_15_" gradientUnits="userSpaceOnUse" x1="37.5" y1="52.5615" x2="39.625" y2="52.5615">
			<stop offset="0" style="stop-color:#920000" />
			<stop offset="0.0824" style="stop-color:#A70000" />
			<stop offset="0.2824" style="stop-color:#D70000" />
			<stop offset="0.4356" style="stop-color:#F40000" />
			<stop offset="0.5225" style="stop-color:#FF0000" />
			<stop offset="0.599" style="stop-color:#F50000" />
			<stop offset="0.7277" style="stop-color:#DB0000" />
			<stop offset="0.892" style="stop-color:#B10000" />
			<stop offset="1" style="stop-color:#920000" />
		</linearGradient>
		<linearGradient id="red_16_" gradientUnits="userSpaceOnUse" x1="21.2959" y1="40.1973" x2="24.5879" y2="40.1973">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_17_" gradientUnits="userSpaceOnUse" x1="55.3799" y1="35.3223" x2="58.6719" y2="35.3223">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_18_" gradientUnits="userSpaceOnUse" x1="27.9277" y1="40.1973" x2="30.6707" y2="40.1973">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_19_" gradientUnits="userSpaceOnUse" x1="41.5947" y1="40.1973" x2="44.3377" y2="40.1973">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_20_" gradientUnits="userSpaceOnUse" x1="49.3447" y1="40.1973" x2="52.0877" y2="40.1973">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>
		<linearGradient id="red_21_" gradientUnits="userSpaceOnUse" x1="34.4277" y1="35.3223" x2="37.1707" y2="35.3223">
			<stop offset="0" style="stop-color:#2E0000" />
			<stop offset="0.1011" style="stop-color:#320000" />
			<stop offset="0.2113" style="stop-color:#400000" />
			<stop offset="0.25" style="stop-color:#460000" />
			<stop offset="0.5" style="stop-color:#8D0000" />
			<stop offset="0.75" style="stop-color:#460000" />
			<stop offset="0.7981" style="stop-color:#3D0000" />
			<stop offset="0.8972" style="stop-color:#320000" />
			<stop offset="1" style="stop-color:#2E0000" />
		</linearGradient>

		<linearGradient id="yellow_1_" gradientUnits="userSpaceOnUse" x1="23.251" y1="11.6665" x2="56.251" y2="11.6665">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_3_" gradientUnits="userSpaceOnUse" x1="2.251" y1="73" x2="63.251" y2="73">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_6_" gradientUnits="userSpaceOnUse" x1="22.417" y1="35.708" x2="57.668" y2="35.708">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_7_" gradientUnits="userSpaceOnUse" x1="10.8086" y1="-0.4702" x2="42.8086" y2="17.1968">
			<stop offset="0.5225" style="stop-color:#FFFF00" />
			<stop offset="0.599" style="stop-color:#F5F500" />
			<stop offset="0.7277" style="stop-color:#DBDB00" />
			<stop offset="0.892" style="stop-color:#B1B100" />
			<stop offset="1" style="stop-color:#929100" />
		</linearGradient>
		<linearGradient id="yellow_8_" gradientUnits="userSpaceOnUse" x1="34.667" y1="3.833" x2="44.918" y2="3.833">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_9_" gradientUnits="userSpaceOnUse" x1="36.084" y1="0.833" x2="44.167" y2="0.833">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_12_" gradientUnits="userSpaceOnUse" x1="19.833" y1="59.3745" x2="58.375" y2="59.3745">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_13_" gradientUnits="userSpaceOnUse" x1="19.4375" y1="52.5615" x2="21.5625" y2="52.5615">
			<stop offset="0" style="stop-color:#929100" />
			<stop offset="0.0824" style="stop-color:#A7A700" />
			<stop offset="0.2824" style="stop-color:#D7D600" />
			<stop offset="0.4356" style="stop-color:#F4F400" />
			<stop offset="0.5225" style="stop-color:#FFFF00" />
			<stop offset="0.599" style="stop-color:#F5F500" />
			<stop offset="0.7277" style="stop-color:#DBDB00" />
			<stop offset="0.892" style="stop-color:#B1B100" />
			<stop offset="1" style="stop-color:#929100" />
		</linearGradient>
		<linearGradient id="yellow_14_" gradientUnits="userSpaceOnUse" x1="56.9375" y1="52.5615" x2="59.0625" y2="52.5615">
			<stop offset="0" style="stop-color:#929100" />
			<stop offset="0.0824" style="stop-color:#A7A700" />
			<stop offset="0.2824" style="stop-color:#D7D600" />
			<stop offset="0.4356" style="stop-color:#F4F400" />
			<stop offset="0.5225" style="stop-color:#FFFF00" />
			<stop offset="0.599" style="stop-color:#F5F500" />
			<stop offset="0.7277" style="stop-color:#DBDB00" />
			<stop offset="0.892" style="stop-color:#B1B100" />
			<stop offset="1" style="stop-color:#929100" />
		</linearGradient>
		<linearGradient id="yellow_15_" gradientUnits="userSpaceOnUse" x1="37.5" y1="52.5615" x2="39.625" y2="52.5615">
			<stop offset="0" style="stop-color:#929100" />
			<stop offset="0.0824" style="stop-color:#A7A700" />
			<stop offset="0.2824" style="stop-color:#D7D600" />
			<stop offset="0.4356" style="stop-color:#F4F400" />
			<stop offset="0.5225" style="stop-color:#FFFF00" />
			<stop offset="0.599" style="stop-color:#F5F500" />
			<stop offset="0.7277" style="stop-color:#DBDB00" />
			<stop offset="0.892" style="stop-color:#B1B100" />
			<stop offset="1" style="stop-color:#929100" />
		</linearGradient>
		<linearGradient id="yellow_16_" gradientUnits="userSpaceOnUse" x1="21.2959" y1="40.1973" x2="24.5879" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_17_" gradientUnits="userSpaceOnUse" x1="55.3799" y1="35.3223" x2="58.6719" y2="35.3223">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_18_" gradientUnits="userSpaceOnUse" x1="27.9277" y1="40.1973" x2="30.6707" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_19_" gradientUnits="userSpaceOnUse" x1="41.5947" y1="40.1973" x2="44.3377" y2="40.1973">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
		<linearGradient id="yellow_20_" gradientUnits="userSpaceOnUse" x1="49.3447" y1="40.1973" x2="52.0877" y2="40.1973">
			<stop offset="0" style="stop-color:#6E6000" />
			<stop offset="0.1011" style="stop-color:#626400" />
			<stop offset="0.2113" style="stop-color:#707000" />
			<stop offset="0.25" style="stop-color:#767600" />
			<stop offset="0.5" style="stop-color:#BDBA00" />
			<stop offset="0.75" style="stop-color:#767600" />
			<stop offset="0.7981" style="stop-color:#6D6E00" />
			<stop offset="0.8972" style="stop-color:#726400" />
			<stop offset="1" style="stop-color:#6E6000" />
		</linearGradient>
		<linearGradient id="yellow_21_" gradientUnits="userSpaceOnUse" x1="34.4277" y1="35.3223" x2="37.1707" y2="35.3223">
			<stop offset="0" style="stop-color:#2E6000" />
			<stop offset="0.1011" style="stop-color:#326400" />
			<stop offset="0.2113" style="stop-color:#407000" />
			<stop offset="0.25" style="stop-color:#467600" />
			<stop offset="0.5" style="stop-color:#8DBA00" />
			<stop offset="0.75" style="stop-color:#467600" />
			<stop offset="0.7981" style="stop-color:#3D6E00" />
			<stop offset="0.8972" style="stop-color:#326400" />
			<stop offset="1" style="stop-color:#2E6000" />
		</linearGradient>
	</defs>
	<!-- mono -->
    <g :visibility="fState[0]">
		<rect x="23.251" y="6" fill="url(#SP_SVGID_1_)" width="33" height="11.333" />
		<rect y="61.749" fill="url(#SP_SVGID_2_)" width="16.75" height="3.584" />
		<path fill="url(#SP_SVGID_3_)" d="M63.251,78.667c0,1.104-0.896,2-2,2h-57c-1.104,0-2-0.896-2-2V67.333c0-1.104,0.896-2,2-2h57
			c1.104,0,2,0.896,2,2V78.667z" />
		<polygon fill="url(#SP_SVGID_4_)" points="9.417,91.333 7.084,91.333 6.084,80.667 10.417,80.667 	" />
		<polygon fill="url(#SP_SVGID_5_)" points="58.583,91.333 56.25,91.333 55.25,80.667 59.583,80.667 	" />
		<rect x="22.417" y="17.333" fill="url(#SP_SVGID_6_)" width="35.251" height="36.75" />
		<rect x="32.834" y="13.5" fill="url(#SP_SVGID_7_)" width="13.5" height="3.833" />
		<rect x="38.251" y="11.333" fill="#1A1A1A" width="3" height="2.167" />
		<rect x="34.667" y="1.666" fill="url(#SP_SVGID_8_)" width="10.251" height="4.334" />
		<rect x="36.084" fill="url(#SP_SVGID_9_)" width="8.083" height="1.666" />
		<rect x="25.501" y="4.916" fill="url(#SP_SVGID_10_)" width="7.333" height="1.084" />
		<polygon fill="url(#SP_SVGID_11_)" points="31.834,4.916 26.501,4.916 27.501,1.883 30.834,1.883 	" />
		<rect x="19.833" y="54.749" fill="url(#SP_SVGID_12_)" width="38.542" height="9.251" />
		<rect x="16.75" y="53.312" fill="#1A1A1A" width="44.708" height="1.438" />
		<rect x="19.438" y="51.812" fill="url(#SP_SVGID_13_)" width="2.125" height="1.5" />
		<rect x="56.938" y="51.812" fill="url(#SP_SVGID_14_)" width="2.125" height="1.5" />
		<rect x="37.5" y="51.812" fill="url(#SP_SVGID_15_)" width="2.125" height="1.5" />
		<rect x="21.084" y="27.083" fill="url(#SP_SVGID_16_)" width="2.5" height="26.229" />
		<rect x="55.168" y="17.333" fill="url(#SP_SVGID_17_)" width="2.5" height="35.979" />
		<rect x="27.751" y="27.083" fill="url(#SP_SVGID_18_)" width="2.083" height="26.229" />
		<rect x="41.418" y="27.083" fill="url(#SP_SVGID_19_)" width="2.083" height="26.229" />
		<rect x="49.168" y="27.083" fill="url(#SP_SVGID_20_)" width="2.083" height="26.229" />
		<rect x="34.251" y="17.333" fill="url(#SP_SVGID_21_)" width="2.083" height="35.979" />
		<rect x="54.834" y="16.666" fill="url(#SP_SVGID_22_)" width="2.084" height="2.084" />
		<rect x="23.251" y="16.666" fill="url(#SP_SVGID_23_)" width="2.084" height="2.084" />
		<line fill="none" stroke="#1A1A1A" x1="32.834" y1="13.5" x2="46.334" y2="13.5" />
		<line fill="none" stroke="#1A1A1A" x1="46.334" y1="13.5" x2="46.334" y2="17.333" />
		<polygon fill="#1A1A1A" points="58.375,63.166 58.375,64 40.646,64 40.646,63.166 37.563,63.166 37.563,64 19.833,64 
			19.833,63.166 16.75,63.166 16.75,64 16.75,65.333 19.833,65.333 37.563,65.333 40.646,65.333 58.375,65.333 61.458,65.333 
			61.458,64 61.458,63.166 	" />
	</g>
	<!-- red -->
    <g :visibility="fState[5]">
		<rect x="23.251" y="6" fill="url(#red_1_)" width="33" height="11.333" />
		<path fill="url(#red_3_)" d="M63.251,78.667c0,1.104-0.896,2-2,2h-57c-1.104,0-2-0.896-2-2V67.333c0-1.104,0.896-2,2-2h57
			c1.104,0,2,0.896,2,2V78.667z" />
		<rect x="22.417" y="17.333" fill="url(#red_6_)" width="35.251" height="36.75" />
		<rect x="32.834" y="13.5" fill="url(#red_7_)" width="13.5" height="3.833" />
		<rect x="38.251" y="11.333" fill="#1A1A1A" width="3" height="2.167" />
		<rect x="34.667" y="1.666" fill="url(#red_8_)" width="10.251" height="4.334" />
		<rect x="36.084" fill="url(#red_9_)" width="8.083" height="1.666" />
		<rect x="19.833" y="54.749" fill="url(#red_12_)" width="38.542" height="9.251" />
		<rect x="16.75" y="53.312" fill="#1A1A1A" width="44.708" height="1.438" />
		<rect x="19.438" y="51.812" fill="url(#red_13_)" width="2.125" height="1.5" />
		<rect x="56.938" y="51.812" fill="url(#red_14_)" width="2.125" height="1.5" />
		<rect x="37.5" y="51.812" fill="url(#red_15_)" width="2.125" height="1.5" />
		<rect x="21.084" y="27.083" fill="url(#red_16_)" width="2.5" height="26.229" />
		<rect x="55.168" y="17.333" fill="url(#red_17_)" width="2.5" height="35.979" />
		<rect x="27.751" y="27.083" fill="url(#red_18_)" width="2.083" height="26.229" />
		<rect x="41.418" y="27.083" fill="url(#red_19_)" width="2.083" height="26.229" />
		<rect x="49.168" y="27.083" fill="url(#red_20_)" width="2.083" height="26.229" />
		<rect x="34.251" y="17.333" fill="url(#red_21_)" width="2.083" height="35.979" />
		<line fill="none" stroke="#1A1A1A" x1="32.834" y1="13.5" x2="46.334" y2="13.5" />
		<line fill="none" stroke="#1A1A1A" x1="46.334" y1="13.5" x2="46.334" y2="17.333" />
		<polygon fill="#1A1A1A" points="58.375,63.166 58.375,64 40.646,64 40.646,63.166 37.563,63.166 37.563,64 19.833,64 
			19.833,63.166 16.75,63.166 16.75,64 16.75,65.333 19.833,65.333 37.563,65.333 40.646,65.333 58.375,65.333 61.458,65.333 
			61.458,64 61.458,63.166 	" />
	</g>
	<g :visibility="fState[5]">
		<rect x="23.251" y="6" fill="url(#red_1_)" width="33" height="11.333" />
		<path fill="url(#red_3_)" d="M63.251,78.667c0,1.104-0.896,2-2,2h-57c-1.104,0-2-0.896-2-2V67.333c0-1.104,0.896-2,2-2h57
			c1.104,0,2,0.896,2,2V78.667z" />
		<rect x="22.417" y="17.333" fill="url(#red_6_)" width="35.251" height="36.75" />
		<rect x="32.834" y="13.5" fill="url(#red_7_)" width="13.5" height="3.833" />
		<rect x="38.251" y="11.333" fill="#1A1A1A" width="3" height="2.167" />
		<rect x="34.667" y="1.666" fill="url(#red_8_)" width="10.251" height="4.334" />
		<rect x="36.084" fill="url(#red_9_)" width="8.083" height="1.666" />
		<rect x="19.833" y="54.749" fill="url(#red_12_)" width="38.542" height="9.251" />
		<rect x="16.75" y="53.312" fill="#1A1A1A" width="44.708" height="1.438" />
		<rect x="19.438" y="51.812" fill="url(#red_13_)" width="2.125" height="1.5" />
		<rect x="56.938" y="51.812" fill="url(#red_14_)" width="2.125" height="1.5" />
		<rect x="37.5" y="51.812" fill="url(#red_15_)" width="2.125" height="1.5" />
		<rect x="21.084" y="27.083" fill="url(#red_16_)" width="2.5" height="26.229" />
		<rect x="55.168" y="17.333" fill="url(#red_17_)" width="2.5" height="35.979" />
		<rect x="27.751" y="27.083" fill="url(#red_18_)" width="2.083" height="26.229" />
		<rect x="41.418" y="27.083" fill="url(#red_19_)" width="2.083" height="26.229" />
		<rect x="49.168" y="27.083" fill="url(#red_20_)" width="2.083" height="26.229" />
		<rect x="34.251" y="17.333" fill="url(#red_21_)" width="2.083" height="35.979" />
		<line fill="none" stroke="#1A1A1A" x1="32.834" y1="13.5" x2="46.334" y2="13.5" />
		<line fill="none" stroke="#1A1A1A" x1="46.334" y1="13.5" x2="46.334" y2="17.333" />
		<polygon fill="#1A1A1A" points="58.375,63.166 58.375,64 40.646,64 40.646,63.166 37.563,63.166 37.563,64 19.833,64 
			19.833,63.166 16.75,63.166 16.75,64 16.75,65.333 19.833,65.333 37.563,65.333 40.646,65.333 58.375,65.333 61.458,65.333 
			61.458,64 61.458,63.166 	" />
	</g>
	<!-- yellow -->
  <g :visibility="fState[2]">
		<rect x="23.251" y="6" fill="url(#yellow_1_)" width="33" height="11.333" />
		<path fill="url(#yellow_3_)" d="M63.251,78.667c0,1.104-0.896,2-2,2h-57c-1.104,0-2-0.896-2-2V67.333c0-1.104,0.896-2,2-2h57
			c1.104,0,2,0.896,2,2V78.667z" />
		<rect x="22.417" y="17.333" fill="url(#yellow_6_)" width="35.251" height="36.75" />
		<rect x="32.834" y="13.5" fill="url(#yellow_7_)" width="13.5" height="3.833" />
		<rect x="38.251" y="11.333" fill="#1A1A1A" width="3" height="2.167" />
		<rect x="34.667" y="1.666" fill="url(#yellow_8_)" width="10.251" height="4.334" />
		<rect x="36.084" fill="url(#yellow_9_)" width="8.083" height="1.666" />
		<rect x="19.833" y="54.749" fill="url(#yellow_12_)" width="38.542" height="9.251" />
		<rect x="16.75" y="53.312" fill="#1A1A1A" width="44.708" height="1.438" />
		<rect x="19.438" y="51.812" fill="url(#yellow_13_)" width="2.125" height="1.5" />
		<rect x="56.938" y="51.812" fill="url(#yellow_14_)" width="2.125" height="1.5" />
		<rect x="37.5" y="51.812" fill="url(#yellow_15_)" width="2.125" height="1.5" />
		<rect x="21.084" y="27.083" fill="url(#yellow_16_)" width="2.5" height="26.229" />
		<rect x="55.168" y="17.333" fill="url(#yellow_17_)" width="2.5" height="35.979" />
		<rect x="27.751" y="27.083" fill="url(#yellow_18_)" width="2.083" height="26.229" />
		<rect x="41.418" y="27.083" fill="url(#yellow_19_)" width="2.083" height="26.229" />
		<rect x="49.168" y="27.083" fill="url(#yellow_20_)" width="2.083" height="26.229" />
		<rect x="34.251" y="17.333" fill="url(#yellow_21_)" width="2.083" height="35.979" />
		<line fill="none" stroke="#1A1A1A" x1="32.834" y1="13.5" x2="46.334" y2="13.5" />
		<line fill="none" stroke="#1A1A1A" x1="46.334" y1="13.5" x2="46.334" y2="17.333" />
		<polygon fill="#1A1A1A" points="58.375,63.166 58.375,64 40.646,64 40.646,63.166 37.563,63.166 37.563,64 19.833,64 
			19.833,63.166 16.75,63.166 16.75,64 16.75,65.333 19.833,65.333 37.563,65.333 40.646,65.333 58.375,65.333 61.458,65.333 
			61.458,64 61.458,63.166 	" />


	</g>
	<!-- green -->
  <g :visibility="fState[1]">
		<rect x="23.251" y="6" fill="url(#green_1_)" width="33" height="11.333" />
		<path fill="url(#green_3_)" d="M63.251,78.667c0,1.104-0.896,2-2,2h-57c-1.104,0-2-0.896-2-2V67.333c0-1.104,0.896-2,2-2h57
			c1.104,0,2,0.896,2,2V78.667z" />
		<rect x="22.417" y="17.333" fill="url(#green_6_)" width="35.251" height="36.75" />
		<rect x="32.834" y="13.5" fill="url(#green_7_)" width="13.5" height="3.833" />
		<rect x="38.251" y="11.333" fill="#1A1A1A" width="3" height="2.167" />
		<rect x="34.667" y="1.666" fill="url(#green_8_)" width="10.251" height="4.334" />
		<rect x="36.084" fill="url(#green_9_)" width="8.083" height="1.666" />
		<rect x="19.833" y="54.749" fill="url(#green_12_)" width="38.542" height="9.251" />
		<rect x="16.75" y="53.312" fill="#1A1A1A" width="44.708" height="1.438" />
		<rect x="19.438" y="51.812" fill="url(#green_13_)" width="2.125" height="1.5" />
		<rect x="56.938" y="51.812" fill="url(#green_14_)" width="2.125" height="1.5" />
		<rect x="37.5" y="51.812" fill="url(#green_15_)" width="2.125" height="1.5" />
		<rect x="21.084" y="27.083" fill="url(#green_16_)" width="2.5" height="26.229" />
		<rect x="55.168" y="17.333" fill="url(#green_17_)" width="2.5" height="35.979" />
		<rect x="27.751" y="27.083" fill="url(#green_18_)" width="2.083" height="26.229" />
		<rect x="41.418" y="27.083" fill="url(#green_19_)" width="2.083" height="26.229" />
		<rect x="49.168" y="27.083" fill="url(#green_20_)" width="2.083" height="26.229" />
		<rect x="34.251" y="17.333" fill="url(#green_21_)" width="2.083" height="35.979" />
		<line fill="none" stroke="#1A1A1A" x1="32.834" y1="13.5" x2="46.334" y2="13.5" />
		<line fill="none" stroke="#1A1A1A" x1="46.334" y1="13.5" x2="46.334" y2="17.333" />
		<polygon fill="#1A1A1A" points="58.375,63.166 58.375,64 40.646,64 40.646,63.166 37.563,63.166 37.563,64 19.833,64 
			19.833,63.166 16.75,63.166 16.75,64 16.75,65.333 19.833,65.333 37.563,65.333 40.646,65.333 58.375,65.333 61.458,65.333 
			61.458,64 61.458,63.166 	" />
	</g>

</svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "submersibl_pump",
  mixins: [MixinStates],
};
</script>
